import { DATE_FORMAT } from "@/constants/datetime";
import { LearnerStatusTag } from "@/features/learner/components/LearnerStatusTag";
import { text } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Box, Grid, Stack, styled, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";

type LearnerTitleProps = {
  fullName?: string;
  planStatus?: string;
  createdAt?: string;
  updatedAt?: string;
};

export const LearnerTitle: FCC<LearnerTitleProps> = ({ fullName, planStatus, createdAt, updatedAt }) => {
  const { learnerId } = useParams();
  const learnerTitle = fullName ? `外国人情報 - ${fullName}` : "新規外国人登録";

  return (
    <TitleContainer>
      <Grid container direction="column" gap={2}>
        <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
          <Typography variant="head20Bold">{learnerTitle}</Typography>
          {planStatus && <LearnerStatusTag planStatus={planStatus} variant="bold" />}
        </Stack>
        <Stack>
          {learnerId && (
            <Box display="flex" alignItems="center" gap={2}>
              <Typography variant="body14" color={text.secondary} sx={{ display: "flex", alignItems: "center" }}>
                登録日：
                <span>{createdAt ? dayjs(createdAt).format(DATE_FORMAT) : ""}</span>
              </Typography>
              <Typography variant="body14" color={text.secondary} sx={{ display: "flex", alignItems: "center" }}>
                更新日：
                <span>{updatedAt ? dayjs(updatedAt).format(DATE_FORMAT) : ""}</span>
              </Typography>
            </Box>
          )}
        </Stack>
      </Grid>
    </TitleContainer>
  );
};

const TitleContainer = styled(Stack)`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: self-start;
  margin-bottom: 24px;
`;
